import { type ApolloError, useQuery } from "@apollo/client";

import { useSelectedOrganizationContainer } from "../../shared/hooks";
import { getRemoteAssetsQuota } from "../api/queries/getRemoteAssetsQuota";
import {
    type GetRemoteAssetsQuotaQuery,
    type GetRemoteAssetsQuotaQueryVariables,
} from "../api/queries/getRemoteAssetsQuota.gql-generated";

interface RemoteAssetsQuotaResult {
    quota: GetRemoteAssetsQuotaQuery["remoteAssetsQuota"] | null;
    loading: boolean;
    error: ApolloError | undefined;
}

export const useRemoteAssetsQuota = (): RemoteAssetsQuotaResult => {
    const { orgId } = useSelectedOrganizationContainer();

    const { data, loading, error } = useQuery<GetRemoteAssetsQuotaQuery, GetRemoteAssetsQuotaQueryVariables>(
        getRemoteAssetsQuota,
        {
            variables: { organizationId: orgId ?? "" },
            skip: !orgId,
        },
    );

    return {
        quota: data?.remoteAssetsQuota ?? null,
        loading,
        error,
    };
};
